import {
  ApiIndividualResponse,
  ApiPaginatedResponse,
  ApiSortingParams,
} from '@/types/api'
import {
  IRecommendation,
  IRecommendationOnTheList,
} from '@/types/recommendations'
import { ApiService, RequestOptions } from './api'

interface LearningRecommendationsFilters {
  sortBy?: ApiSortingParams
  status?: 'not_generated' | 'ready' | 'generating' | 'error'
  [key: string]: string | number | boolean | undefined | ApiSortingParams
}

export interface LearningRecommendationsPagination {
  page?: number
  limit?: number
}

export type ListLearningRecommendationsOptions = {
  filters?: LearningRecommendationsFilters
  pagination?: LearningRecommendationsPagination
  options?: RequestOptions
}

export class LearningRecommendationsService {
  static readonly path = '/learning-recommendations'
  static readonly recommendationPath = '/learning-recommendations/:id'

  static readonly httpClient = new ApiService()

  static async list({
    filters = {},
    pagination = {},
    options,
  }: ListLearningRecommendationsOptions = {}): Promise<
    ApiPaginatedResponse<IRecommendationOnTheList>
  > {
    let url = LearningRecommendationsService.path
    const queryParams = new URLSearchParams()

    if (pagination.limit) {
      queryParams.append('limit', pagination.limit.toString())
    }
    if (pagination.page) {
      queryParams.append('page', pagination.page.toString())
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === 'sortBy' && typeof value === 'object') {
          Object.entries(value).forEach(([field, direction]) => {
            queryParams.append('sortBy', `${field}[${direction}]`)
          })
        } else {
          queryParams.append(key, value.toString())
        }
      }
    })

    if (queryParams.toString()) {
      url = `${url}?${queryParams.toString()}`
    }

    return await LearningRecommendationsService.httpClient.get(url, options)
  }

  static async getLearningRecommendationById(
    id: string,
    options?: RequestOptions
  ): Promise<ApiIndividualResponse<IRecommendation>> {
    return await LearningRecommendationsService.httpClient.get(
      LearningRecommendationsService.recommendationPath.replace(':id', id),
      options
    )
  }

  static async createLearningRecommendation(
    options?: RequestOptions
  ): Promise<ApiIndividualResponse<IRecommendation>> {
    return await LearningRecommendationsService.httpClient.post(
      LearningRecommendationsService.path,
      {},
      options
    )
  }
}
